import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function fondRoutes($stateProvider: StateProvider) {
    let fondsModule: { default: any; };
    $stateProvider
        .state({
            name: 'fonds',
            url: '/fonds',
            component:  KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => fondsModule.default,
            },
            lazyLoad: async () => {
                fondsModule = await import(/* webpackChunkName: "fonds" */ './KpFonds.svelte');
                return null;
            }
        });
}